import { doRequest } from '@r1-frontend/do-request';
import {
    getConnectPrice,
    IGetConnectPriceRequestDto,
    IGetConnectPriceResponseDto,
} from '@r1-frontend/api-domru/api-request/v1/get-connect-price';

import { TContextDispatch } from '~/src/entities/speed-bonus/context';
import { setConnectionCost, toggleIsLoading } from '~/src/entities/speed-bonus/context/actions';
import { Plus100Status } from '~/src/entities/speed-bonus/context/constants';
import { TInitialState } from '~/src/entities/speed-bonus/context/reducer';

export const fetchConnectPrice = () => async(dispatch: TContextDispatch, getState: () => TInitialState) => {
    const { tariff } = getState();

    if (!tariff) {
        return;
    }

    dispatch(toggleIsLoading(true));

    const requestData: IGetConnectPriceRequestDto = {
        needTv: 0,
        needInt: 1,
        install: 2,
        int100: tariff.speedBonusStatus === Plus100Status ? 1 : 0,
    };

    const response = await doRequest.apiRequest<IGetConnectPriceResponseDto>(
        getConnectPrice(requestData),
    );

    if (response.isSuccess) {
        const { action_price, base_price } = response.payload;
        dispatch(setConnectionCost(action_price ?? base_price));
    }

    dispatch(toggleIsLoading(false));
};
